module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACRJREFUeNpiZGBg2M9ARcDEQGUwauCogaMGjho4auBQMRAgwAA63wDniG/BMgAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/dark_rounded/contentPattern.png
 ** module id = 67
 ** module chunks = 0
 **/